module.exports = __webpack_public_path__ + "img/ihp-diagram.2404b642.png";